<template>
	<table>
		<ScheduleRowHead></ScheduleRowHead>
		<tbody>
			<ScheduleRow v-for="(patient, index) in patients"
				:key="'' + index + patient.data.name"
				:first="index == 0"
				v-model="patient.data"
				v-bind:events="events"
				@remove="removeRow(index)">
			</ScheduleRow>
		</tbody>
	</table>
</template>

<script>
import PatientList from './mixin/patient-list'
import ScheduleRowHead from '../head/Schedule'
import ScheduleRow from '../row/Schedule'
export default {
	name: 'patient-schedule-table',
	mixins: [ PatientList ],
	components: {
		ScheduleRowHead,
		ScheduleRow
	}
}
</script>
